exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip{display:none!important}@media screen and (max-width:639px){.fancyrange__inputWrapper{font-size:1rem}.fancyrange__label,.js--fancyrange__input{font-size:16px}}.fancyrange__input{text-align:right;padding-right:4px}", ""]);

// exports
